import { useEffect, useState } from "react";
import Confetti from "react-confetti";

import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";
import Portal from "Utilities/PortalMaker";

import SignupOption from "../SignupOption";

export default function ConfettiOption() {
  const {
    options: { showConfetti },
    signupListStatusID,
  } = useGetCurrentSignupList();

  const isOn = showConfetti > 0;
  const [shouldPreview, setShouldPreview] = useState(isOn);

  useEffect(() => {
    setShouldPreview((prev) => !prev && isOn);
  }, [isOn]);

  return (
    <>
      <SignupOption
        text="Show confetti when a member completes a Signup"
        name="showConfetti"
        on={isOn}
        disabled={signupListStatusID !== 1}
      />
      {shouldPreview && (
        <Portal to={document.getElementById("FnrConfettiHolder")}>
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            recycle={false}
            numberOfPieces={600}
            tweenDuration={5000}
          />
        </Portal>
      )}
    </>
  );
}
